import withErrorBoundary from 'utils/framework/hocs/withErrorBoundary/withErrorBoundary';

export default withErrorBoundary;
